import { useContext } from "react";

import { Select, SelectDataType } from "@sso/components/Form";
import { TableContext } from "@sso/context/tableContext";
import { useAppDispatch } from "@sso/hooks/useRedux";

const pageOption: SelectDataType[] = [10, 20, 30, 50, 100].map(number => ({ key: number, value: number, label: number.toString() }));

export const TableHeaderPageSize = () => {
  const dispatch = useAppDispatch();
  const { pageSize } = useContext(TableContext);

  const handleOnChange = (data: SelectDataType) => {
    dispatch(pageSize.action(Number(data.value)));
  };

  if (!pageSize) {
    return null;
  }
  return (
    <Select
      width="80px"
      margin="0"
      clearable={false}
      value={{ key: pageSize.value, value: pageSize.value, label: pageSize.value.toString() }}
      items={pageOption}
      fieldProps={{ padding: "0.4rem" }}
      onChange={handleOnChange}
    />
  );
};
